import { checkType } from '../checkType/checkType';
/**
 * Compare two arrays
 * @param firstArray - The first array to compare
 * @param secondArray - The second array to compare
 * @returns true if arrays are equal, otherwise false
 */
var compareArray = function (firstArray, secondArray) {
    if (firstArray.length !== secondArray.length)
        return false;
    return firstArray.every(function (item, index) {
        return comparisonValues(item, secondArray[index]);
    });
};
/**
 * Compare two values of various types
 * @param firstValue - The first value to compare
 * @param secondValue - The second value to compare
 * @returns true if values are equal, otherwise false
 */
export var comparisonValues = function (firstValue, secondValue) {
    if (firstValue === secondValue)
        return true;
    if (checkType(firstValue, 'date') && checkType(secondValue, 'date')) {
        return firstValue.getTime() === secondValue.getTime();
    }
    if (checkType(firstValue, 'array') && checkType(secondValue, 'array')) {
        return compareArray(firstValue, secondValue);
    }
    if (checkType(firstValue, 'object') && checkType(secondValue, 'object')) {
        var objA = firstValue;
        var objB = secondValue;
        if (Object.keys(objA).length !== Object.keys(objB).length)
            return false;
        if (Object.is(objA, objB))
            return true;
        for (var key in objA) {
            if (!objB.hasOwnProperty(key) || !comparisonValues(objA[key], objB[key]))
                return false;
        }
        return true;
    }
    return String(firstValue) === String(secondValue);
};
